import PriorityHighIcon from "@material-ui/icons/PriorityHigh";
import {FormattedMessage} from "react-intl";
import messages from "@super-template/messages";
import {FormHelperText} from "@material-ui/core";
import {add, isBefore, parse} from "date-fns";

export const isAgeOver = (personId, age) => {
  const date = parse(personId.substring(0, 4) + (personId[6] === '-' ? '19' : '20') +
    personId.substring(4, 6), 'ddMMyyyy', new Date());
  return isBefore(add(date, {years: age}), new Date());
};

export default ({id, personId}) => (
  isAgeOver(personId, 100) &&
  <FormHelperText id={id} style={{color: "#066F20"}}>
    <PriorityHighIcon style={{fontSize: "1rem", verticalAlign: "sub"}}/>
    <FormattedMessage {...messages[`warning_personId`]}/>
  </FormHelperText>
)
